<script setup>
import KraftchatAIRulesSwitchItem from './KraftchatAIRulesSwitchItem.vue';

import { safetyOptions } from '../../helpers/kraftchatAIRulesConfig';

const props = defineProps({
  policy: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['update:policy']);

const updateSafetySetting = (key, value) => {
  emit('update:policy', {
    ...props.policy,
    safety_settings: {
      ...(props.policy.safety_settings || {}),
      [key]: value,
    },
  });
};
</script>

<template>
  <div class="grid gap-3 md:grid-cols-2">
    <KraftchatAIRulesSwitchItem
      v-for="setting in safetyOptions"
      :key="setting.key"
      :label="setting.title"
      :description="setting.description"
      :model-value="policy.safety_settings?.[setting.key]"
      @update:model-value="updateSafetySetting(setting.key, $event)"
    />
  </div>
</template>
